// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__CZOi5","updateInformation":"styles_updateInformation__ar5zK","checkUpdateButton":"styles_checkUpdateButton__wx8RG"};